<template>
  <div>
    <g-breadcrumb :paginas="paginaStatus.caminhoMigalha" />
    <q-card>
      <q-card-main>
        <div class="row">
          <div class="col-sm-8 col-xs-6">
            <g-input
              id="refCodigo"
              name="refCodigo"
              ref="refCodigo"
              tipo="text"
              etiqueta="Código"
              validacao="numeric"
              :desabilitar="true"
              :foco="false"
              v-model="paginaStatus.subAssunto.codSubassunto"
            >
            </g-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-autocomplete
              id="refAssunto"
              name="refAssunto"
              ref="refAssunto"
              etiqueta="Assunto"
              valor="codAssunto"
              descricaoPrimaria="desAssunto"
              validacao="required"
              :desabilitar="paginaStatus.desabilitarEdicao"
              :api=apiAssunto
              v-model="paginaStatus.subAssunto.assunto.codAssunto"
            >
            </g-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xs-12">
            <g-input
              id="refDescricao"
              name="refDescricao"
              ref="refDescricao"
              tipo="text"
              etiqueta="Descrição"
              validacao="required | maxlength(100)"
              :tamanho="100"
              :foco="false"
              :desabilitar="paginaStatus.desabilitarEdicao"
              v-model="paginaStatus.subAssunto.desSubassunto"
            >
            </g-input>
          </div>
        </div>
        <div class="row">

          <div class="col-xs-5 col-md-5">
            <g-option
              id="ativo"
              name="ativo"
              ref="refAtivo"
              tipo="radio"
              :option="arrayAtivoEnum"
              :desabilitar="paginaStatus.desabilitarEdicao"
              etiqueta="Ativo"
              validacao="required"
              v-model="indAtivo"
            ></g-option>
          </div>
        </div>
        <div class="row">

          <div class="col-xs-5 col-md-5">
            <g-option
              id="toogleVisivelWeb"
              name="toogleVisivelWeb"
              ref="toogleVisivelWeb"
              tipo="radio"
              :option="arrayAtivoEnum"
              :desabilitar="paginaStatus.desabilitarEdicao"
              etiqueta="Permite solicitação online"
              validacao="required"
              v-model="indWeb"
            ></g-option>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-5 col-md-5">
            <g-option
              id="toogleVisivelWeb"
              name="toogleVisivelWeb"
              ref="toogleVisivelWeb"
              tipo="radio"
              :option="arrayAtivoEnum"
              :desabilitar="paginaStatus.desabilitarEdicao"
              etiqueta="Visível no portal de serviços"
              validacao="required"
              v-model="indVisivelPortal"
            ></g-option>
          </div>
        </div>
        <br />
        <div
          class="row"
          v-if="!desabilitarInformacao"
        >
          <div class="col-sm-12 col-xs-12">
            <q-field
              :error="error"
              error-label="Campo obrigatório não informado"
            >
              <q-editor
                ref="txtInformacaoWeb"
                id="txtInformacaoWeb"
                name="txtInformacaoWeb"
                v-model="txtInformacaoWeb"
                :readonly="readonly"
                validacao="required"
                :disable="paginaStatus.desabilitarEdicao"
                :disabilitar="desabilitarInformacao"
                :toolbar="[
                  ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
                  ['token', 'hr', 'link', 'custom_btn'],
                  ['fullscreen'],
                  [
                    {
                      label: $q.i18n.editor.formatting,
                      icon: $q.icon.editor.formatting,
                      list: 'no-icons',
                      options: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'code']
                    },
                    {
                      label: $q.i18n.editor.fontSize,
                      icon: $q.icon.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: ['size-1', 'size-2', 'size-3', 'size-4', 'size-5', 'size-6', 'size-7']
                    },
                    {
                      label: $q.i18n.editor.defaultFont,
                      icon: $q.icon.editor.font,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: ['default_font', 'arial', 'arial_black', 'comic_sans', 'courier_new', 'impact', 'lucida_grande', 'times_new_roman', 'verdana']
                    },
                    'removeFormat'
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],
                  [
                    {
                      label: $q.i18n.editor.align,
                      icon: $q.icon.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify']
                    }
                  ],
                  ['undo', 'redo']
                ]"
                :fonts="{
                  arial: 'Arial',
                  arial_black: 'Arial Black',
                  comic_sans: 'Comic Sans MS',
                  courier_new: 'Courier New',
                  impact: 'Impact',
                  lucida_grande: 'Lucida Grande',
                  times_new_roman: 'Times New Roman',
                  verdana: 'Verdana'
                }"
              />
            </q-field>
          </div>
        </div>
      </q-card-main>
    </q-card>
    <div class="col-12 text-right pad-20t-h10-80b">
      <q-btn
        round
        id="btnSalvar"
        name="btnSalvar"
        class="fixed"
        color="positive"
        icon="check"
        size="lg"
        @click="salvar"
        style="right: 18px; bottom:18px"
        v-show="!paginaStatus.desabilitarEdicao"
      >
        <q-tooltip>Salvar</q-tooltip>
      </q-btn>
    </div>
  </div>
</template>

<script>

import api from 'components/util/api'
import msg from 'components/util/msg'
import util from 'components/util/util'
import utilHttp from 'components/util/utilHttp'
import GInput from 'components/util/gInput'
import GOption from 'components/util/gOption'
import GSelect from 'components/util/gSelect'
import GAutocomplete from 'components/util/gAutocomplete'
import GBreadcrumb from 'components/util/gBreadcrumb'
import constante from 'components/util/constante'

export default {
  data () {
    return {
      error: false,
      arrayAtivoEnum: constante.ATIVO_ENUM,
      visualizando: false,
      indAtivo: '',
      indVisivelPortal: '',
      mensagemErro: '',
      mensagemAjuda: '',
      chaveLocalStorage: 'subAssunto',
      apiAssunto: api.ASSUNTO,
      indWeb: '',
      readonly: false,
      desabilitarInformacao: false,
      desabilitarEdicao: false,
      txtInformacaoWeb: '',
      paginaStatus: {
        subAssunto: {
          assunto: {}
        },
        caminhoMigalha: [
          {
            icone: '',
            descricao: '',
            rotaNome: ''
          }
        ]
      }
    }
  },
  watch: {
    paginaStatus: {
      handler (valor) {
        if (valor) {
          util.adicionarNoStorage(this.chaveLocalStorage, valor)
        } else util.removerDoStorage(this.chaveLocalStorage)
      },
      deep: true
    },
    indWeb: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.subAssunto.indWeb = this.indWeb
        }
        if (this.indWeb === 'N' && this.paginaStatus.operacao.descricao === 'Visualizar Subassunto') {
          this.desabilitarInformacao = false
        } else if (this.indWeb === 'N' && this.paginaStatus.operacao.descricao !== 'Visualizar Subassunto') {
          this.desabilitarInformacao = false
        } else {
          this.txtInformacaoWeb = ''
          this.paginaStatus.subAssunto.txtInformacaoWeb = ''
          this.desabilitarInformacao = true
        }
      },
      deep: true
    },
    txtInformacaoWeb: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.subAssunto.txtInformacaoWeb = this.txtInformacaoWeb
          this.error = false
        } else {
          this.error = true
        }
      },
      deep: true
    },
    indVisivelPortal: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.subAssunto.indVisivelPortal = this.indVisivelPortal
        }
      },
      deep: true
    },
    indAtivo: {
      handler (valor) {
        if (valor) {
          this.paginaStatus.subAssunto.indAtivo = this.indAtivo
        }
      },
      deep: true
    }
  },
  methods: {
    salvar () {
      var self = this
      if (self.indWeb === 'N') {
        if (self.txtInformacaoWeb === '' || self.txtInformacaoWeb === undefined) {
          self.error = true
        } else {
          self.error = false
        }
      } else { self.error = false }
      if (util.validarComponentes(this.$refs)) {
        if (self.error === true) {
          util.exibirToastAviso('Favor corrigir campo inválido')
          return
        }
        self.paginaStatus.subAssunto.codUsuario = self.$login.getCodUsuario()
        if (self.paginaStatus.operacao.descricao === 'Novo') {
          self.paginaStatus.subAssunto.indAnonimo = 'N'
          utilHttp.httpPostCarregando(api.SUB_ASSUNTO, self.paginaStatus.subAssunto, resposta => {
            if (resposta.status === 201) {
              util.exibirToastSucesso(msg.m(2))
              util.retornarCaminhoMigalhaPaginaAnterior(this)
            } else {
              util.exibirToastFalha('Erro ao salvar Categoria')
            }
          })
        } else if (self.paginaStatus.operacao.descricao === 'Editar Subassunto') {
          var filtro = '/'.concat(self.paginaStatus.subAssunto.codSubassunto)
          utilHttp.httpPutCarregando(api.SUB_ASSUNTO.concat(filtro), self.paginaStatus.subAssunto, resposta => {
            if (resposta.status === 200) {
              util.exibirToastSucesso(msg.m(3))
              util.retornarCaminhoMigalhaPaginaAnterior(this)
            }
          })
        }
      }
    }
  },
  mounted () {
    if (this.$route.params.paginaStatus) {
      this.paginaStatus = this.$route.params.paginaStatus
      this.paginaStatus.caminhoMigalha.push({
        icone: this.paginaStatus.operacao.icone,
        descricao: this.paginaStatus.operacao.descricao,
        rotaNome: 'subAssunto'
      })
    } else if (util.recuperarDoStorage(this.chaveLocalStorage)) {
      this.paginaStatus = util.recuperarDoStorage(this.chaveLocalStorage)
    }
    if (this.paginaStatus.operacao.descricao !== 'Novo') {
      this.$refs['refAssunto'].carregar(this.paginaStatus.subAssunto.assunto.codAssunto, this.paginaStatus.subAssunto.assunto.desAssunto)
      this.indWeb = this.paginaStatus.subAssunto.indWeb
      this.txtInformacaoWeb = this.paginaStatus.subAssunto.txtInformacaoWeb
    } else {
      this.indWeb = 'S'
    }
    if (this.paginaStatus.operacao.descricao !== 'Novo') {
      this.indVisivelPortal = this.paginaStatus.subAssunto.indVisivelPortal
      this.indAtivo = this.paginaStatus.subAssunto.indAtivo
    } else {
      this.indVisivelPortal = 'S'
      this.indAtivo = 'S'
    }
  },

  components: { GBreadcrumb, GInput, GSelect, GAutocomplete, GOption }

}
</script>
